/** @module @csi/widget/LabeledWidget */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/form/Button",
	"underscore",
	"dojo/text!./LabeledWidget.html"
], function(declare,_TemplatedMixin,_WidgetBase,Button,_,template) {
	
	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-labeled-widget",
		templateString: template,
		
		// attach points
		widgetNode: null,
		
		/** @property {string} label - label to display after count */
		label: "",

		/** @property {string} separator - separator between label and widget */
		separator: ":",
		
		/** @property {Function} widgetClass - class to use to create widget */ 
		widgetClass: Button,
		
		/** @property {Object} widgetProperties - properties to pass to widget when created */
		widgetProperties: null,

		/**
		 * @override
		 * Create widget on startup
		 */
		startup: function() {
			if (!this._started) {
				this.inherited(arguments);
				
				const params = _.extend({
					disabled: this.disabled
				}, this.widgetProperties);
				
				new this.widgetClass(params).placeAt(this.widgetNode);
			}
		}
	});
});